var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{staticStyle:{"width":"800px","height":"600px"},attrs:{"center":_vm.center1,"zoom":12,"map-type-id":"terrain"}},[_c('GmapMarker',{attrs:{"position":_vm.center1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }